import React from 'react';
import { useSelector } from 'react-redux';

import { COLOR_ITEM, HEIGHT_ONE_PERCENT, ITEM_PERCENT_HEIGHT, ITEM_PERCENT_PADDING_TOP } from '../const';
import useStatusEditProject from '../hooks/useStatusEditProject';
import { RootState } from '../store';
import { ItemType } from '../types';
import GantItemGradient from './gantItemGradient';
import GantItemListOfGroupTask from './gantItemListOfGroupTask';
import GantItemMarker from './gantItemMarker';
import GantItemMarkerBondDrop from './gantItemMarkerBondDrop';
import GantItemMarkerPercentage from './gantItemMarkerPercentage';
import GantItemSetMarkerBond from './gantItemSetMarkerBond';
import { useDisplayingItemMarker } from './hook/useDisplayingItemMarker';

interface IGantItemSimple {
    propsPath: React.SVGProps<SVGPathElement & SVGRectElement>;
    item: ItemType;
    x: number;
    widthItem: number;
    onOverMouse: () => void;
    isOverMouse: boolean;
    accessView: boolean;
    accessEdit: boolean;
}

const GantItemSimple: React.FC<IGantItemSimple> = ({
    propsPath,
    item,
    accessView,
    accessEdit,
    x,
    widthItem,
    onOverMouse,
    isOverMouse,
}) => {
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);

    const isEditableProject = useStatusEditProject(item.projectId);
    const isMarkerDisplay = useDisplayingItemMarker(item.id, isOverMouse);

    const mainBox = () => {
        return (
            <>
                <rect
                    key={item.id}
                    {...propsPath}
                    x={x}
                    y={HEIGHT_ONE_PERCENT * ITEM_PERCENT_PADDING_TOP}
                    width={widthItem}
                    height={HEIGHT_ONE_PERCENT * ITEM_PERCENT_HEIGHT}
                    fill={`url(#fillStatus-${item.id})`}
                />
                <GantItemListOfGroupTask item={item} offsetX={x} />
            </>
        );
    };

    return (
        <g
            style={{
                opacity: accessView || accessEdit ? 1 : 0.5,
                filter: accessView || accessEdit ? 'none' : 'grayscale(100%)',
                transition: 'all 0.3s ease',
            }}
        >
            {accessEdit && <GantItemSetMarkerBond item={item} x={x} widthItem={widthItem} isOverMouse={isOverMouse} />}

            <GantItemGradient
                itemId={item.id}
                percentage={item.completionPercentage}
                color={item.color || COLOR_ITEM}
            />
            {mainBox()}
            {isMarkerDisplay &&
                isEditableProject &&
                !currentDragBond &&
                accessEdit && [
                    <GantItemMarker
                        key={`leftMarker-${item.id}`}
                        item={item}
                        x={x}
                        onOverMouse={onOverMouse}
                        draggingType={'left'}
                    />,
                    <GantItemMarker
                        key={`rightMarker-${item.id}`}
                        item={item}
                        x={x + widthItem}
                        onOverMouse={onOverMouse}
                        draggingType={'right'}
                    />,
                    !item.tasks.length ? (
                        <GantItemMarkerPercentage
                            key={`markerPercentage-${item.id}`}
                            item={item}
                            x={x + (widthItem / 100) * item.completionPercentage}
                        />
                    ) : null,
                ]}
            {accessView && currentDragBond && accessEdit && currentDragBond?.id !== item.id && (
                <>
                    <GantItemMarkerBondDrop item={item} x={x} draggingType={'bondLeft'} />
                    <GantItemMarkerBondDrop item={item} x={x + widthItem} draggingType={'bondRight'} />
                </>
            )}
        </g>
    );
};

export default React.memo(GantItemSimple);
